<template>
  <div class="login">
    <div class="log_warp">
      <div>
        <el-form :model="loggin" status-icon :rules="logginYZ" ref="loggin" class="mar_top">
          <el-form-item label prop="account">
            <el-col :span="24">
              <el-input placeholder="请输入用户名" v-model="loggin.account">
                <i slot="prefix" class="el-input__icon fa fa-user-o"></i>
              </el-input>
            </el-col>
          </el-form-item>
          <el-form-item label prop="password">
            <el-col :span="24">
              <el-input
                placeholder="密码"
                :show-password="true"
                type="password"
                v-model="loggin.password"
              >
                <i slot="prefix" class="el-input__icon fa fa-lock"></i>
              </el-input>
            </el-col>
          </el-form-item>

          <el-form-item>
            <el-col :span="24">
              <el-button :autofocus="true" @click="loginAdmin('loggin')" class="btn_login"
                >登录
              </el-button>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "login",
  components: {},
  data() {
    return {
      loggin: {},
      logginYZ: {
        account: [{ required: true, message: "用户名不能为空", trigger: "blur" }],
        password: [{ required: true, message: "密码不能为空", trigger: "blur" }],
      },
    };
  },
  methods: {
    loginAdmin(formName) {
      this.$refs[formName].validate((valid) => {
        this.$api.getUser.login(this.loggin).then((res) => {
          if (res.code == 1) {
            this.$u.vuex("userInfo", res.data.userinfo);
            this.$router.push("/index");
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.login {
  position: relative;
  background: #5dd5c8 url("@/assets/newbg.png") center bottom no-repeat;
  height: 100vh;
  width: 100%;
  overflow: hidden;
}
.log_warp {
  width: 410px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 5px;
  box-shadow: 1px 2px 15px rgba(0, 0, 0, 0.3);
  padding: 100px 40px;
}
.btn_login {
  height: 40px;
  background: #5dd5c8;
  width: 100%;
  text-align: center;
  color: #fff;
  font-size: 16px;
}
</style>
